import { Logo } from "./types";

export default async function fetchLogo(): Promise<Logo> {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/logo?${process.env.NEXT_PUBLIC_API_QUERY_PARAMS}`,
    { cache: "no-store" }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch logos");
  }

  const data: Logo[] = await response.json();
  return data[0];
}
